<script>
import validate from '@/mixins/validate';
export default {
    name: 'BaseField',
    mixins: [validate],
    props: {
        value: {
            type: [String, Number, Boolean, Object, Array, Date, Function, File],
            default: null
        },
        testId: {
            type: String,
            default: null
        },
        refPrefix: {
            type: String,
            default: 'input.'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: Boolean,
            default: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        description: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        hint: {
            type: String,
            default: null
        },
        rules: {
            type: Array,
            default: () => []
        },
        error: {
            type: Boolean,
            default: false
        },
        errorMessages: {
            type: Array,
            default: () => []
        },
        min: {
            type: [Number, String],
            default: null
        },
        max: {
            type: [Number, String],
            default: null
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
        hideLabel: {
            type: Boolean,
            default: false
        },
        hidePlaceholder: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: null
        },
        info: {
            type: String,
            default: null
        },
        preventDefaultValue: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        validation: {
            type: Array,
            default: () => []
        },
        mask: {
            type: [Object, Function],
            default: null
        },
        prependText: {
            type: String,
            default: null
        },
        appendText: {
            type: String,
            default: null
        }
    },
    data: () => ({
        typeText: null,
        labelText: null,
        descriptionText: null,
        placeholderText: null,
        hintText: null,
        rulesArray: [],
        errorMessagesArray: []
    }),
    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        typeValue() {
            if (this._.isNull(this.type) && this._.isNull(this.typeText)) {
                return null;
            }

            return this.type || this.typeText;
        },
        labelValue() {
            if (this.hideLabel) {
                return null;
            }

            if (this._.isNull(this.label) && this._.isNull(this.labelText)) {
                return null;
            }

            return this.label || this.labelText;
        },
        descriptionValue() {
            if (this._.isNull(this.description) && this._.isNull(this.descriptionText)) {
                return null;
            }

            return this.description || this.descriptionText;
        },
        placeholderValue() {
            if (this._.isNull(this.placeholder) && this._.isNull(this.placeholderText)) {
                return null;
            }

            return this.placeholder || this.placeholderText;
        },
        hintValue() {
            if (this._.isNull(this.hint) && this._.isNull(this.hintText)) {
                return null;
            }

            return this.hint || this.hintText;
        },
        rulesValue() {
            const rules = [];

            if (this.validation && this.validation.length) {
                this.validation.forEach(rule => {
                    const { validator, args } = this.getValidatorFromString(rule);
                    rules.push(() => validator(this.inputValue, this.labelValue, ...args));
                });
            }

            if (this.min && !this.validation.some(rule => rule.startsWith('min:'))) {
                rules.push(() => this.getValidator('min')(this.inputValue, this.labelValue, this.min));
            }

            if (this.max && !this.validation.some(rule => rule.startsWith('max:'))) {
                rules.push(() => this.getValidator('max')(this.inputValue, this.labelValue, this.max));
            }

            if (this.required && !this.validation.some(rule => rule.startsWith('required'))) {
                rules.push(() => this.getValidator('required')(this.inputValue, this.labelValue));
            }

            return [...this.rules, ...this.rulesArray, ...rules];
        },
        errorMessagesValue() {
            if (this._.isNull(this.errorMessages) && this._.isNull(this.errorMessagesArray)) {
                return null;
            }

            if (!this._.isEmpty(this.errorMessages)) {
                return this.errorMessages;
            }

            return this.errorMessagesArray;
        }
    }
};
</script>
